import React from 'react';

import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { createQuickInsertMatcher } from '@atlaskit/editor-common/quick-insert/create-quick-insert-matcher';
import {
	AI_IMAGE_GENERATION_MENU_ITEM,
	MEDIA_SECTION,
} from '@atlaskit/editor-common/quick-insert/keys';
import { MEDIA_SECTION_RANK } from '@atlaskit/editor-common/quick-insert/rank';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { RegisterMenuItem } from '@atlaskit/editor-ui-control-model/types';

import type { AIImageGenerationPlugin } from '../../aiImageGenerationPluginType';

import { AIImageGenerationQuickInsertMenuItem } from './AIImageGenerationQuickInsertMenuItem';

type Params = {
	api: ExtractInjectionAPI<AIImageGenerationPlugin> | undefined;
	isImageGenerationEnabled: boolean;
};

export const getAIImageGenerationQuickInsertComponents = ({
	api,
	isImageGenerationEnabled,
}: Params): RegisterMenuItem[] => [
	{
		key: AI_IMAGE_GENERATION_MENU_ITEM.key,
		type: AI_IMAGE_GENERATION_MENU_ITEM.type,
		parents: [
			{
				key: MEDIA_SECTION.key,
				type: MEDIA_SECTION.type,
				rank: MEDIA_SECTION_RANK[AI_IMAGE_GENERATION_MENU_ITEM.key],
			},
		],
		match: createQuickInsertMatcher(({ formatMessage }) => ({
			description: formatMessage(messages.aiImageGenerationDescription),
			keywords: ['ai', 'generate', 'image', 'create', 'picture'],
			title: formatMessage(messages.aiImageGeneration),
		})),
		component: () => <AIImageGenerationQuickInsertMenuItem api={api} />,
		isHidden: () =>
			!isImageGenerationEnabled ||
			!api?.malleableUi ||
			!api?.media?.sharedState.currentState()?.mediaProvider,
	},
];
